export default __webpack_public_path__ + "static/media/img53.ce35bacf.jpg";